
let listData = [
  {
    path: '/',
    name: 'userInfo',
    component: () => import('@/views/userInfo/userInfo'),
    meta: {
      title: '个人信息'
    }
  },

  {
    path: 'Password',
    name: 'password',
    component: () => import('@/views/Password'),
    meta: {
      title: '密码修改'
    }

  },
  // {
  //   path: 'SignUp',
  //   name: 'SignUp',
  //   component: () => import('@/views/SignUp'),
  //   meta: {
  //     title: '中考报名'
  //   }
  // },
  // {
  //   path: 'ExaminationSite',
  //   name: 'ExaminationSite',
  //   component: () => import('@/views/ExaminationSite'),
  //   meta: {
  //     title: '考点查询'
  //   }
  // },
  // {
  //   path: 'SportScoreQuery',
  //   name: 'SportScoreQuery',
  //   component: () => import('@/views/SportScoreQuery'),
  //   meta: {
  //     title: '体育成绩查询'
  //   }
  // },
  // {
  //   path: 'ScoreQuery',
  //   name: 'ScoreQuery',
  //   component: () => import('@/views/ScoreQuery'),
  //   meta: {
  //     title: '成绩查询'
  //   }
  // },
   {
    path: 'Volunteer',
    name: 'Volunteer',
    component: () => import('@/views/Volunteer'),
    meta: {
      title: '志愿填报'
    }
  },
  // {
  //   path: 'EnrollmentPlan',
  //   name: 'EnrollmentPlan',
  //   component: () => import('@/views/EnrollmentPlan'),
  //   meta: {
  //     title: '招生计划'
  //   }
  // },
  // {
  //   path: 'AdmissionInquiry',
  //   name: 'AdmissionInquiry',
  //   component: () => import('@/views/AdmissionInquiry'),
  //   meta: {
  //     title: '录取查询'
  //   }
  // },
  {
    path: 'volunteerRecord',
    name: 'volunteerRecord',
    component: () => import('@/views/volunteerRecord'),
    meta: {
      title: '历史志愿查询'
    }
  },  {
    path: 'volunteerRecord2',
    name: 'volunteerRecord2',
    component: () => import('@/views/volunteerRecord/index2'),
    meta: {
      title: '补录志愿查询'
    }
  },
  // {
  //   path: 'ArtRegistion',
  //   name: 'ArtRegistion',
  //   component: () => import('@/views/ArtRegistion'),
  //   meta: {
  //     title: '特长生报名'
  //   }
  // },
  // {
  //   path: 'specialVolunteer',
  //   name: 'specialVolunteer',
  //   component: () => import('@/views/specialVolunteer'),
  //   meta: {
  //     title: '中央民族大学附属中学志愿填报'
  //   }
  // },

]

export default listData
